import React from "react";
import TwoColumnLayout from "layout/TwoColumnLayout";
import ListTemplate from "components/ListTemplate";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import UserAdminOneRowCard from "./UserAdminOneRowCard";
import ClientFilter from "components/filters/Filters/ClientFilter";
import UserToClientLifecycleFilter from "components/filters/Filters/UserToClientLifecycleFilter";
import EnvironmentFilter from "components/filters/Filters/EnvironmentFilter";
import HubSpotLinkedFilter from "components/filters/Filters/HubSpotLinkedFilter";
import { useLoaderData } from "react-router";

const AdminOneUserListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.UserForAdminOneListFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ListTemplate
        title={viewModel.pageTitle}
        filterSet="user_ListAdminOne"
        defaultFilters={viewModel.defaultFilters}
        initialInstruction={viewModel.initialInstruction}
        fetchFunction={window.CoreApi.UserForAdminOne.Paginated}
        getId={item => item.userId}
        layout={{
          type: "card",
          sections: {
            renderTitle: () => null,
            renderFooter: () => null,
            hideFooter: () => true,
            hideTitle: () => true,
            renderBody: (item) => <UserAdminOneRowCard user={item} />
          }
        }}
        filters={<>
          <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
          <ClientFilter />
          <UserToClientLifecycleFilter />
          <EnvironmentFilter />
          <HubSpotLinkedFilter />
        </>}
        functions={{
          mapResponseToFilterValues,
          mapFilterValuesToInstruction
        }}
      />
    </TwoColumnLayout.LeftColumn>
  </TwoColumnLayout>
};

export default AdminOneUserListApp;